// import React, { useRef, useState, useCallback, useEffect } from 'react'

// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import { useTranslations } from "../../hooks/useTranslations"

const DateTimePickerComponent = ({ formik, config = {}, ...other }) => {

    const { t } = useTranslations({ ns: ["common"] })

    // const {
    //     values = {}, 
    //     errors = {}, 
    //     touched = {}, 
    //     // handleChange, 
    //     setFieldValue
    // } = formik;

    // const {
    //     name = "documentdate",
    //     label = "Document Date",
    //     renderValue, // render display way
    // } = config

    // const getValue = () => {

    //     if(renderValue){
    //         return renderValue({ values })
    //     }

    //     return values[name]
    // }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DateTimePicker']} sx={{ m: 0, p: 0 }}>
                <DateTimePicker
                    autoFocus
                    label={t("dateTime")}
                    formatDensity={"dense"}
                    // {...other}
                    slotProps={{
                        textField: {
                            size: "small",
                            margin: "dense",
                            sx: {
                                backgroundColor: '#fff',
                                borderColor: '#fff',
                                borderWidth: 1,
                                borderStyle: 'solid'
                            }
                        }
                    }}
                />
            </DemoContainer>
        </LocalizationProvider>
    )

}

export default DateTimePickerComponent;